/**
 * Global and Facility Admin Menu Configurations
 *
 * Extracted from SidebarContent for better organization
 */

export const globalAdminMenuConfig = {
  key: "admin",
  titleId: "sidebar.admin",
  items: [
    {
      type: "submenu",
      key: "administrations",
      titleId: "sidebar.globalAdministration",
      icon: "GlobalOutlined",
      items: [
        {
          key: "administrations/global/dashboard",
          path: "/administrations/global/dashboard",
          titleId: "sidebar.GlobalAdminDashboard",
        },
        {
          key: "administrations/global/manageFacility",
          path: "/administrations/global/manageFacility",
          titleId: "sidebar.manageFacility",
        },
        {
          key: "administrations/global/tierUsers",
          path: "/administrations/global/tierUsers",
          titleId: "sidebar.manageTierUsers",
        },
        {
          key: "administrations/global/testResultConfiguration",
          path: "/administrations/global/testResultConfiguration",
          titleId: "sidebar.testResultConfiguration",
        },
        {
          key: "administrations/global/supportRequests",
          path: "/administrations/global/support-requests",
          titleId: "sidebar.supportRequests",
        },
      ],
    },
  ],
};

export const facilityAdminMenuConfig = {
  key: "facility_admin",
  titleId: "sidebar.facilityAdmin",
  items: [
    {
      type: "submenu",
      key: "facility-administrations",
      titleId: "sidebar.facilityAdministration",
      icon: "BankOutlined",
      items: [
        {
          key: "administrations/facility/facilityUsers",
          path: "/administrations/facility/facilityUsers",
          titleId: "sidebar.manageFacilityUser",
        },
        {
          key: "administrations/facility/testService",
          path: "/administrations/facility/testService",
          titleId: "sidebar.manageTestType",
        },
        {
          key: "administrations/facility/tat",
          path: "/administrations/facility/tat",
          titleId: "sidebar.manageTAT",
        },
        {
          key: "administrations/facility/testMeasures",
          path: "/administrations/facility/testMeasures",
          titleId: "sidebar.manageFacilityTestMeasure",
        },
        {
          key: "administrations/facility/machineSetting",
          path: "/administrations/facility/machineSetting",
          titleId: "sidebar.manageMachineSetting",
          facilityTypes: ["public", "private"], // Only for public/private facilities
        },
        {
          key: "administrations/facility/manage-qc-test-config",
          path: "/administrations/facility/manage-qc-test-config",
          titleId: "sidebar.manageQCTestConfiguration",
          facilityTypes: ["public", "private"], // Only for public/private facilities
        },
      ],
    },
    {
      type: "submenu",
      key: "commodities",
      titleId: "sidebar.facilityInventory",
      icon: "ScheduleOutlined",
      items: [
        {
          key: "commodities/createAsset",
          path: "/commodities/createAsset",
          titleId: "sidebar.createAsset",
        },
        {
          key: "commodities/asset",
          path: "/commodities/asset",
          titleId: "sidebar.manageAsset",
        },
        {
          key: "commodities/bulkCheckOutAsset",
          path: "/commodities/bulkCheckOutAsset",
          titleId: "sidebar.bulkCheckoutAsset",
        },
      ],
    },
    {
      type: "submenu",
      key: "commodities_consumables",
      titleId: "sidebar.facilityConsumables",
      icon: "ScheduleOutlined",
      items: [
        {
          key: "commodities/createConsumable",
          path: "/commodities/createConsumable",
          titleId: "sidebar.createConsumables",
        },
        {
          key: "commodities/consumable",
          path: "/commodities/consumable",
          titleId: "sidebar.manageConsumables",
        },
      ],
    },
  ],
};

export const fileManagementMenuConfig = {
  key: "File Management",
  titleId: "sidebar.documents.fileManagement",
  items: [
    {
      key: "file-management/documents",
      path: "/file-management/documents",
      titleId: "sidebar.documents",
      icon: "FileWordOutlined",
    },
    {
      key: "file-management/recent-folders",
      path: "/file-management/recent-folders",
      title: "Recent Folder",
      icon: "FolderViewOutlined",
    },
    {
      key: "file-management/recent-files",
      path: "/file-management/recent-files",
      title: "Recent files",
      icon: "FileSearchOutlined",
    },
    {
      key: "file-management/upload-files",
      path: "/file-management/upload-files",
      titleId: "sidebar.interoperability.upload",
      icon: "FileSearchOutlined",
    },
    {
      key: "log",
      path: "/log",
      titleId: "sidebar.interoperability.sync",
      icon: "FileSearchOutlined",
    },
  ],
};

export const nonConformityMenuConfig = {
  key: "Non Conformities",
  titleId: "sidebar.non_conformities",
  items: [
    {
      key: "non-conformity",
      path: "/non-conformity",
      title: "Non Conformity",
      icon: "FileProtectOutlined",
    },
  ],
};
